const ServiceProjects = ({ service }) => {
  if (!service.projects?.length) return null;

  return (
    <section className="py-24 bg-white">
      <div className="container-custom">

        <div className="text-center mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Related Projects
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            Recent Projects
          </h2>

        </div>

        <div className="grid md:grid-cols-3 gap-8">

          {service.projects.map((project, index) => (
            <div
              key={index}
              className="rounded-3xl overflow-hidden shadow-lg"
            >

              <img
                src={project.image}
                alt={project.title}
                className="w-full h-72 object-cover"
              />

              <div className="p-6">

                <h3 className="text-xl font-bold text-[#082B57]">
                  {project.title}
                </h3>

              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default ServiceProjects;